import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// NOTE: preconnect / dns-prefetch / the hero LCP <link rel="preload">
// and the non-blocking Google Fonts stylesheet now live as static
// <link> tags in public/index.html. Static tags are found by the
// browser's HTML preload scanner before any JS downloads or runs,
// so they help LCP; injecting them here from JS was always too late
// to matter for the first paint. Keep them in sync there if the hero
// image (IMAGES1[0] in Home.jsx) ever changes.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
